import { Dialog } from "@mui/material";
import { ContainerCameras } from "./containerMenuCameras";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

export function MenuOrderingContainerCameras({
    showMenuOrderingCameras,
    handleCloseMenuOrderingCameras,
    idRegiao
}) {
    return (
        <Dialog
        onClose={handleCloseMenuOrderingCameras} 
        open={showMenuOrderingCameras}
        >
            <DndProvider backend={HTML5Backend}>
                <ContainerCameras 
                idRegiao={idRegiao}
                />
            </DndProvider>
        </Dialog>
    )
}